const faceSize = 86;
const faceHeight = 60;

export const GreatFace = () => (
  <svg
    width={faceSize}
    height={faceHeight}
    viewBox={`0 0 ${faceSize} ${faceHeight}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 1.58594C32.8574 1.58594 42 10.1268 42 20.5859C42 31.0451 32.8574 39.5859 21.5 39.5859C10.1426 39.5859 1 31.0451 1 20.5859C1 10.1268 10.1426 1.58594 21.5 1.58594Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <path
      d="M64.5 1.875C75.8574 1.875 85 10.4158 85 20.875C85 31.3342 75.8574 39.875 64.5 39.875C53.1426 39.875 44 31.3342 44 20.875C44 10.4158 53.1426 1.875 64.5 1.875Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <circle cx="62" cy="16.5859" r="2.5" fill="black" />
    <circle cx="24" cy="16.5859" r="2.5" fill="black" />
    <path
      d="M5 43.375H81M5.55117 43.375C54.2261 71.1877 58.0045 55.5188 80.5044 43.6455"
      stroke="black"
      strokeLinecap="round"
      strokeWidth="3"
    />
  </svg>
);

export const GoodFace = () => (
  <svg
    width={faceSize}
    height={faceHeight}
    viewBox={`0 0 ${faceSize} ${faceHeight - 3}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 2.21094C32.3762 2.21094 41 10.3726 41 20.2109C41 30.0493 32.3762 38.2109 21.5 38.2109C10.6238 38.2109 2 30.0493 2 20.2109C2 10.3726 10.6238 2.21094 21.5 2.21094Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <path
      d="M64.5 2.5C75.3762 2.5 84 10.6616 84 20.5C84 30.3384 75.3762 38.5 64.5 38.5C53.6238 38.5 45 30.3384 45 20.5C45 10.6616 53.6238 2.5 64.5 2.5Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <circle cx="74" cy="15.5" r="2.5" fill="black" />
    <circle cx="31" cy="15.5" r="2.5" fill="black" />
    <path
      d="M3.02197 43C54.9988 65.8214 54.9687 50.8954 83.0215 43.2887"
      stroke="black"
      strokeWidth="3"
    />
  </svg>
);

export const OkayFace = () => (
  <svg
    width={faceSize}
    height={faceHeight}
    viewBox={`0 0 ${faceSize} ${faceHeight - 13}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 2.02344C32.3762 2.02344 41 10.1851 41 20.0234C41 29.8618 32.3762 38.0234 21.5 38.0234C10.6238 38.0234 2 29.8618 2 20.0234C2 10.1851 10.6238 2.02344 21.5 2.02344Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <path
      d="M64.5 2.3125C75.3762 2.3125 84 10.4741 84 20.3125C84 30.1509 75.3762 38.3125 64.5 38.3125C53.6238 38.3125 45 30.1509 45 20.3125C45 10.4741 53.6238 2.3125 64.5 2.3125Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <circle cx="65" cy="20.0234" r="2.5" fill="black" />
    <circle cx="24" cy="20.0234" r="2.5" fill="black" />
    <path
      d="M3.00098 44.8125C55.0569 45.7131 54.9747 45.2428 83.0005 45.1012"
      stroke="black"
      strokeWidth="3"
    />
  </svg>
);

export const DownFace = () => (
  <svg
    width={faceSize}
    height={faceHeight}
    viewBox={`0 0 ${faceSize} ${faceHeight - 3}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 2.21094C32.3762 2.21094 41 10.3726 41 20.2109C41 30.0493 32.3762 38.2109 21.5 38.2109C10.6238 38.2109 2 30.0493 2 20.2109C2 10.3726 10.6238 2.21094 21.5 2.21094Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <path
      d="M64.5 2.5C75.3762 2.5 84 10.6616 84 20.5C84 30.3384 75.3762 38.5 64.5 38.5C53.6238 38.5 45 30.3384 45 20.5C45 10.6616 53.6238 2.5 64.5 2.5Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <circle cx="67" cy="28.7891" r="2.5" fill="black" />
    <circle cx="22" cy="28.7891" r="2.5" fill="black" />
    <path
      d="M3.02197 55.2891C54.9988 32.4676 54.9687 47.3936 83.0215 55.0003"
      stroke="black"
      strokeWidth="3"
    />
  </svg>
);

export const BadFace = () => (
  <svg
    width={faceSize}
    height={faceHeight}
    viewBox={`0 2 ${faceSize} ${faceHeight}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 3.35547C32.3762 3.35547 41 11.5171 41 21.3555C41 31.1938 32.3762 39.3555 21.5 39.3555C10.6238 39.3555 2 31.1938 2 21.3555C2 11.5171 10.6238 3.35547 21.5 3.35547Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <path
      d="M64.5 3.64453C75.3762 3.64453 84 11.8062 84 21.6445C84 31.4829 75.3762 39.6445 64.5 39.6445C53.6238 39.6445 45 31.4829 45 21.6445C45 11.8062 53.6238 3.64453 64.5 3.64453Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
    />
    <circle cx="59.5" cy="31.5" r="2.5" fill="black" />
    <circle cx="26.5" cy="31.5" r="2.5" fill="black" />
    <path d="M5 60.1445L81 60.1445" stroke="black" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M5.54883 58.1445C55.5 35.5 48.9956 43 80.502 57.874"
      stroke="black"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);
